// client/src/components/AIAgentDashboard.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import io from 'socket.io-client';

const AIAgentDashboard = () => {
    const [httpInput, setHttpInput] = useState('');
    const [streamInput, setStreamInput] = useState('');
    const [httpResult, setHttpResult] = useState('');
    const [streamResult, setStreamResult] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [socket, setSocket] = useState(null);

    // Initialize socket connection
    useEffect(() => {
        // const newSocket = io('http://localhost:4030');
        const BASE_URL = process.env.REACT_APP_AGENT_BASE_URL;
        const newSocket = io(BASE_URL);
        
        setSocket(newSocket);

        newSocket.on('connect', () => {
            console.log('Connected to AIAgentService');
        });

        newSocket.on('ai_agent_output', (message) => {
            console.log('Received AI agent output:', message);
            setStreamResult(message);
            setLoading(false);
        });

        newSocket.on('ai_agent_error', (error) => {
            console.error('AI agent error:', error);
            setStreamResult('Error occurred: ' + error);
            setLoading(false);
        });

        return () => newSocket.disconnect();
    }, []);

    const handleHttpReason = async () => {
        setLoading(true);
        try {
            console.log('Sending HTTP reason request:', httpInput);
            // const response = await axios.post('http://localhost:4030/api/reason', { input: httpInput });
            const response = await axios.post(process.env.REACT_APP_AGENT_EXTENDED_NEURO_URL + '/reason', { input: httpInput });
            console.log('Received HTTP reason response:', response.data);
            setHttpResult(response.data.result);
        } catch (error) {
            console.error('Error in HTTP reason:', error);
            setHttpResult('Error occurred: ' + error.message);
        }
        setLoading(false);
    };

    const handleStreamReason = useCallback(() => {
        if (socket) {
            setLoading(true);
            console.log('Sending stream reason request:', streamInput);
            socket.emit('ai_agent_input', streamInput);
        } else {
            console.error('Socket not connected');
            setStreamResult('Error: Socket not connected');
        }
    }, [socket, streamInput]);

    const handleGetStatus = async () => {
        try {
            // const response = await axios.get('http://localhost:4030/api/status');
            const response = await axios.get(process.env.REACT_APP_AGENT_EXTENDED_NEURO_URL + '/status');
            console.log('Received status:', response.data);
            setStatus(response.data.status);
        } catch (error) {
            console.error('Error getting status:', error);
            setStatus('Error occurred: ' + error.message);
        }
    };

    return (
        <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
            <h2 className="text-2xl font-bold mb-4">AI Agent Dashboard</h2>
            
            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="httpInput">
                    HTTP Input
                </label>
                <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="httpInput"
                    type="text"
                    value={httpInput}
                    onChange={(e) => setHttpInput(e.target.value)}
                    placeholder="Enter input for HTTP reason"
                />
                <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mt-2"
                    onClick={handleHttpReason}
                    disabled={loading}
                >
                    HTTP Reason
                </button>
                <p className="mt-2">Result: {httpResult}</p>
            </div>

            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="streamInput">
                    Stream Input
                </label>
                <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="streamInput"
                    type="text"
                    value={streamInput}
                    onChange={(e) => setStreamInput(e.target.value)}
                    placeholder="Enter input for stream reason"
                />
                <button
                    className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mt-2"
                    onClick={handleStreamReason}
                    disabled={loading}
                >
                    Stream Reason
                </button>
                <p className="mt-2">Result: {streamResult}</p>
            </div>

            <div className="mb-4">
                <button
                    className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    onClick={handleGetStatus}
                >
                    Get Status
                </button>
                <p className="mt-2">Status: {status}</p>
            </div>

            {loading && (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AIAgentDashboard;
